/* eslint-disable react/destructuring-assignment */
import {
  SET_REFERENCE_ID,
  RESET_REFERENCE_ID,
  UPDATE_UKC_THRESHOLD,
} from '../actions/constants';

const defaultState = {
  referenceId: null,
  threshold: 0,
};

export const LogbookHighlighterReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_REFERENCE_ID: {
      return {
        ...state,
        referenceId: action.referenceId,
      };
    }
    case RESET_REFERENCE_ID: {
      return {
        ...state,
        referenceId: null,
      };
    }
    case UPDATE_UKC_THRESHOLD: {
      const threshold = action.threshold === '' ? 0 : action.threshold / 100; // Convert the centimeters to meters
      return {
        ...state,
        threshold,
      };
    }
    default:
      return state;
  }
};
